import React from "react";

import { formatCalendarDate } from "../../../Utils/helper";

function WitnessSummaryTable({ witnesses = [], onEditWitness }) {
  // Styles for the table rows
  const tableRowStyle = {
    height: "25px",
    lineHeight: "25px",
  };

  const emptyRowStyle = {
    height: "25px",
    width: "100%",
  };

  // Function to get party icon based on party type
  const getPartyIcon = (partyType) => {
    switch (partyType?.toLowerCase()) {
      case "client":
        return <i className="ic ic-15 ic-client m-r-5" />;
      case "defendant":
        return <i className="ic ic-15 ic-defendants m-r-5" />;
      case "other party":
        return <i className="ic ic-15 ic-parties m-r-5" />;
      default:
        return <i className="ic ic-15 ic-parties m-r-5" />;
    }
  };

  // Function to render data rows
  const renderDataRow = (witness, index) => (
    <tr
      key={`witness-${index}`}
      style={{ ...tableRowStyle, cursor: onEditWitness ? "pointer" : "default" }}
      onClick={() => onEditWitness?.(witness)}
    >
      {/* Index */}
      <td
        className="text-center"
        style={{
          minWidth: "25px",
          width: "25px",
          maxWidth: "25px",
        }}
      >
        {index + 1}
      </td>

      {/* Witness */}
      <td className="td-autosize witness-col-1 p-l-5">
        <div className="d-flex align-items-center">
          <span
            className="text-truncate"
            style={{
              fontWeight: "600",
            }}
          >
            {witness.witness_last_name && witness.witness_first_name
              ? `${witness.witness_last_name}, ${witness.witness_first_name}`
              : witness.witness_last_name || witness.witness_first_name || "-"}
          </span>
        </div>
      </td>

      <td />

      {/* For */}
      <td className="td-autosize witness-col-2">
        <div
          className="d-flex align-items-center"
          style={{
            fontWeight: "600",
          }}
        >
          {getPartyIcon(witness.witness_for_entity)}
          <span className="text-truncate">{witness.witness_for_name || ""}</span>
        </div>
      </td>

      <td />

      {/* Concerning */}
      <td className="witness-col-3" style={{ maxWidth: "500px", minWidth: "200px" }}>
        <div
          className="text-truncate"
          style={{
            fontWeight: "600",
          }}
        >
          {witness.statement_concerning || ""}
        </div>
      </td>

      <td />

      {/* Contact */}
      <td
        className="text-center witness-col-4"
        style={{
          fontWeight: "600",
        }}
      >
        <div>
          {witness.contact_confirmed_date ? formatCalendarDate(witness.contact_confirmed_date) : ""}
        </div>
      </td>

      <td />

      {/* Deposition */}
    </tr>
  );

  // Function to render empty rows to reach minimum of 5 rows
  const renderEmptyRows = (dataLength) => {
    const minRows = 5;
    const emptyRowsCount = Math.max(0, minRows - dataLength);

    return Array.from({ length: emptyRowsCount }, (_, index) => (
      <tr key={`empty-${index}`} style={tableRowStyle}>
        <td colSpan={10} className="empty-row">
          <div style={emptyRowStyle}>{/* Empty row */}</div>
        </td>
      </tr>
    ));
  };

  return (
    <div className="custom-tab lit-custom-tab w-100">
      {/* Table */}
      <div className="table-responsive overflow-hidden">
        <table className="table table-borderless table-striped table-treatment has-height-25">
          <thead>
            <tr id="tb-header">
              <th
                className="text-center"
                style={{
                  minWidth: "25px",
                  width: "25px",
                  maxWidth: "25px",
                }}
              >
                {/* Index Header */}
              </th>
              <th className="td-autosize color-grey-2 p-l-5">Witness</th>
              <th />
              <th className="text-center color-grey-2" style={{ width: "1%" }}>
                For
              </th>
              <th />
              <th className="text-center color-grey-2">Concerning</th>
              <th />
              <th className="text-center color-grey-2">Contact</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {witnesses?.map((witness, index) => renderDataRow(witness, index))}
            {renderEmptyRows(witnesses?.length || 0)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default React.memo(WitnessSummaryTable);
